[
  {
    "type": "function",
    "name": "deployVault",
    "inputs": [
      { "name": "vaultOwner", "type": "address" },
      { "name": "salt", "type": "bytes32" }
    ],
    "outputs": [{ "name": "vaultAddress", "type": "address" }],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "deployVaultWithNonce",
    "inputs": [
      { "name": "vaultOwner", "type": "address" },
      { "name": "nonce", "type": "uint256" }
    ],
    "outputs": [
      { "name": "vaultAddress", "type": "address" },
      { "name": "salt", "type": "bytes32" }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "computeVaultAddress",
    "inputs": [
      { "name": "vaultOwner", "type": "address" },
      { "name": "salt", "type": "bytes32" }
    ],
    "outputs": [{ "name": "", "type": "address" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "generateDeterministicSalt",
    "inputs": [
      { "name": "vaultOwner", "type": "address" },
      { "name": "nonce", "type": "uint256" }
    ],
    "outputs": [{ "name": "", "type": "bytes32" }],
    "stateMutability": "pure"
  },
  {
    "type": "function",
    "name": "getOwnerVaults",
    "inputs": [{ "name": "vaultOwner", "type": "address" }],
    "outputs": [{ "name": "", "type": "address[]" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getOwnerVaultCount",
    "inputs": [{ "name": "vaultOwner", "type": "address" }],
    "outputs": [{ "name": "", "type": "uint256" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "isVaultFromFactory",
    "inputs": [{ "name": "vault", "type": "address" }],
    "outputs": [{ "name": "", "type": "bool" }],
    "stateMutability": "view"
  },
  {
    "type": "event",
    "name": "VaultDeployed",
    "inputs": [
      { "name": "vaultAddress", "type": "address", "indexed": true },
      { "name": "owner", "type": "address", "indexed": true },
      { "name": "salt", "type": "bytes32", "indexed": false }
    ]
  }
]
